


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Event } from "@/api/models/Event";

@Component
export default class CalendarCard extends Vue {
    /**
     * Event to display.
     */
    @Prop()
    event: Event;

    /**
     * Get the startTime as a date.
     */
    get startDate(): Date {
        return new Date(this.event.startTime);
    }

    /**
     * Get the endTime as a date.
     */
    get endDate(): Date {
        return new Date(this.event.endTime);
    }
}
